export default {
      id: "download-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#download",
      toString: function () {
        return this.url;
      }
    }